import SectionHeading from "@/components/SectionHeading";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import { waLink } from "@/data/site";

const COLS = [
  {
    title: "Psicoterapia",
    lead: "É um processo de acompanhamento. Pode envolver compreensão e trabalho sobre:",
    items: ["Emoções", "Comportamentos", "Relações", "Experiências", "Dificuldades atuais", "Estratégias e recursos psicológicos"],
    to: "/psicoterapia",
    cta: "Conhecer Psicoterapia",
    testId: "comparativo-psicoterapia",
  },
  {
    title: "Avaliação Neuropsicológica",
    lead: "É um processo avaliativo estruturado, com objetivos definidos a partir da demanda e etapa de devolutiva. Busca compreender de forma integrada:",
    items: ["Funcionamento cognitivo", "Aspectos emocionais", "Aspectos comportamentais"],
    to: "/neuropsicologia",
    cta: "Conhecer Avaliação",
    testId: "comparativo-avaliacao",
  },
];

const Comparativo = () => (
  <section data-testid="comparativo-section" className="border-t border-raiz-900/10 bg-cream py-20 lg:py-28">
    <div className="container-x">
      <SectionHeading eyebrow="06 — Caminhos" title="Psicoterapia ou Avaliação Neuropsicológica?" testId="comparativo" />
      <Stagger className="mt-14 grid gap-6 lg:grid-cols-2" gap={0.14}>
        {COLS.map((c) => (
          <StaggerItem key={c.title} className="h-full">
            <article
              data-testid={c.testId}
              className="group flex h-full flex-col rounded-3xl border border-raiz-900/10 bg-paper p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-raiz-600/50 lg:p-10"
            >
              <h3 className="font-serif text-2xl font-light text-ink lg:text-3xl">{c.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-ink/65">{c.lead}</p>
              <ul className="mt-6 flex flex-wrap gap-2">
                {c.items.map((i) => (
                  <li key={i} className="rounded-full bg-raiz-50 px-4 py-1.5 text-[13px] text-raiz-800">{i}</li>
                ))}
              </ul>
              <div className="mt-8 flex-1" />
              <ArrowButton to={c.to} variant="outline" testId={`${c.testId}-cta`}>
                {c.cta}
              </ArrowButton>
            </article>
          </StaggerItem>
        ))}
      </Stagger>
      <FadeUp delay={0.15} className="mt-12 text-center">
        <p className="font-serif text-xl italic text-ink/75 lg:text-2xl">Ainda não sabe qual procurar?</p>
        <p className="mt-2 text-sm text-ink/55">Você não precisa chegar com essa resposta pronta.</p>
        <div className="mt-6">
          <ArrowButton href={waLink()} target="_blank" rel="noopener noreferrer" testId="comparativo-whatsapp-cta">
            Conversar com Sabrina
          </ArrowButton>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Comparativo;
